module.exports = __webpack_public_path__ + "img/logo_ctt.a7f2d115.png";